// Instagram handles: same rules as the backend (services/profile_requirements.py).
const URL_RE = /^(?:https?:\/\/)?(?:www\.|m\.)?(?:instagram\.com|instagr\.am)\/([^/?#]+)/i;
// Letters, digits, '.', '_' (max 30); no leading/trailing '.', no '..'.
// (No regex lookbehind: older iOS WebViews can't parse it.)
const HANDLE_RE = /^[a-z0-9._]{1,30}$/;
const validHandle = (h) => HANDLE_RE.test(h) && !h.startsWith('.') && !h.endsWith('.') && !h.includes('..');

// '@Asha.Plays' / 'instagram.com/asha.plays' → 'asha.plays'; '' → ''; null if invalid.
export function normaliseInstagram(value) {
  let text = (value || '').trim();
  if (!text) return '';
  const m = text.match(URL_RE);
  if (m) text = m[1];
  else if (text.includes('/')) return null;
  const handle = text.replace(/^@+/, '').trim().toLowerCase();
  return validHandle(handle) ? handle : null;
}

export const instagramUrl = (handle) => `https://www.instagram.com/${handle}/`;
